module.exports = __webpack_public_path__ + "img/img13.860ca5c0.png";